// https://gist.github.com/mkjiau/650013a99c341c9f23ca00ccb213db1c

import axios from 'axios'
let protocol = location.protocol === 'https:' ? 'https' : 'http'
if (protocol == 'https') {
  // En production, il y a une redirection ngnix le protocole disparait
  axios.defaults.baseURL = protocol + '://' + window.location.hostname + '/portail-backend/'
} else {
  axios.defaults.baseURL = protocol + '://' + window.location.hostname + ':4070/portail-backend/'
}

// Axios Intercept Requests
axios.interceptors.request.use(
  async function(config) {
    if (!config.url.includes('public')) {
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

// Axios Intercept Response
axios.interceptors.response.use(null, error => {
  if (error.config && error.response && error.response.status === 401) {
    let errorConfig = error.config
    if (!errorConfig.url.includes('public')) {
      return fetchAccessTokenPromised().then(token => {
        localStorage.setItem('accessToken', token)
        error.config.headers['Authorization'] = 'Bearer ' + token
        console.log('Set new token ' + token.slice(-10))
        return axios.request(error.config)
      })
    }
  }
  return Promise.reject(error)
})

function fetchAccessTokenPromised() {
  let request = { refreshToken: localStorage.getItem('refreshToken') }
  return new Promise(function(resolve, reject) {
    axios
      .post('rest/public/bd/login/refreshToken', request)
      .then(response => {
        // request complete and store
        localStorage.setItem('accessToken', response.data.accessToken)
        console.log('Recieved new access token : ****' + response.data.accessToken.slice(-10))
        resolve(response.data.accessToken)
      })
      .catch(err => {
        reject(err)
      })
  })
}
